var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppHeader'),_c('MobileHeader'),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"90vh"}}),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }